import { render } from "./ModuleTitleCard.vue?vue&type=template&id=5fcae473"
import script from "./ModuleTitleCard.vue?vue&type=script&lang=js"
export * from "./ModuleTitleCard.vue?vue&type=script&lang=js"

import "./ModuleTitleCard.vue?vue&type=style&index=0&id=5fcae473&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__